const CATEGORY_REDIRECTS = require('./categoryRedirects');
const LEGACY_CATEGORY_REDIRECTS = require('./legacyCategoryRedirects');

/**
 * Find the latest path, by first searching the newer method of category redirects and the old.
 * @param {string} path
 * @returns The actual category path
 */
const getLatestCategoryPath = path => {
  const latestPath = Object.keys(CATEGORY_REDIRECTS).find(key => {
    return CATEGORY_REDIRECTS[key]?.includes(path);
  });
  if (latestPath) {
    return latestPath;
  }
  const redirectCat = LEGACY_CATEGORY_REDIRECTS[path];
  return redirectCat;
};

module.exports = getLatestCategoryPath;
